import { useGetAllActiveAlertsQuery } from 'services/alerts/alerts.api';
import NWSAlert from '../NWSAlert';

const NWSAlertsList = ({ localAlerts }) => {
  const { data: allActiveAlerts = [] } = useGetAllActiveAlertsQuery();
  const cwAlertsOnly = allActiveAlerts?.filter((alert) => alert.provider === 'Custom Weather');
  const alertsToDisplay = localAlerts || cwAlertsOnly;

  return (
    <div className="">
      {alertsToDisplay.length > 0 &&
        alertsToDisplay.map((alert, index) => {
          return (
            <div key={index}>
              <NWSAlert alert={alert} />
            </div>
          );
        })}
      {alertsToDisplay.length === 0 && <div className="m-2">No alerts</div>}
    </div>
  );
};

export default NWSAlertsList;
